// Forms & FAQs: the website's accessible HTML edition of each statutory form (v1.3 ticket 14, RCMC-12).
//
// The website (rcmcdelhi.com, since build 0.72) publishes each statutory investor form twice: as a PDF, and as an HTML
// edition an Investor can complete with a keyboard or a screen reader, then print, sign and send
// (`Website QW/…/rcmcdelhi.com/lib/form-edition.php`, RCMC_FORM_EDITIONS). The portal lists the same forms as PDFs
// only, under the file names Operations uploaded them with (Upload Docs keeps a file's own name), so a row is matched
// by its document name, exactly. Any other name (the FAQ, the grievances report, a later upload) gets no link: a
// guessed address that fails is worse than none.
//
// Keep in step with both sides: a new edition on the website, or a statutory form uploaded here under a new name,
// needs a line below. The names are prod's as at 12 Oct 2026, plus "Form ISR-4.pdf", the website's edition, which
// replaces "Form ISR-4-revised_NEW.pdf" at the v1.3 deploy (owner ruling Q21, ticket 17's upload checklist).

const WEBSITE_FORMS = "https://rcmcdelhi.com/resources/investors-corner/forms/";

// Portal document name → [the form, its edition's address on the website]. A Map, so a name such as "constructor"
// can never find an object's built-in keys
const EDITIONS = new Map([
  ["Form ISR-1.pdf", ["Form ISR-1", "isr-1"]],
  ["Form ISR-2.pdf", ["Form ISR-2", "isr-2"]],
  ["Form ISR-3.pdf", ["Form ISR-3", "isr-3"]],
  ["Form ISR-4-revised_NEW.pdf", ["Form ISR-4", "isr-4"]], // prod's current row, retired at the v1.3 deploy
  ["Form ISR-4.pdf", ["Form ISR-4", "isr-4"]],
  ["Form ISR-5.pdf", ["Form ISR-5", "isr-5"]],
  ["Form No. SH-13.pdf", ["Form SH-13", "sh-13"]],
  ["Form No. SH-14.pdf", ["Form SH-14", "sh-14"]],
]);

/**
 * The website's HTML edition of a Forms & FAQs document, if it publishes one.
 * @param {string} documentName  the row's `document_name`, e.g. "Form ISR-1.pdf"
 * @returns {{form: string, href: string} | null}  the form ("Form ISR-1") and its edition's address, else null
 */
export function htmlEdition(documentName) {
  const edition = EDITIONS.get(documentName);
  return edition ? { form: edition[0], href: WEBSITE_FORMS + edition[1] } : null;
}
